import React from 'react'
const Accessibility = (props: any) => {
    return (
        <div className="accessibility-background">
            <div className="container" style={{padding: "0px !important", maxWidth:"1220px"}}>
                <div className="accessibilityText" dangerouslySetInnerHTML={{__html: props.data.description}}></div>
            </div>
        </div>
    )
}

export default Accessibility;
